// extracted by mini-css-extract-plugin
module.exports = {"ai-card__graphic":"AiCard_ai-card__graphic__xJlB6","card":"AiCard_card__mjKva","card__title":"AiCard_card__title__TZ52O","card__content":"AiCard_card__content__kavZ3"};